import React, { Component } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import Layout from '../layout';
import styles from '../styles/pages/affidavit-certification.scss';

class AffidavitCertification extends Component {
    constructor(props) {
        super(props);

        document.title = 'Affidavit Certification';
    }

    render() {
        const Paragraph = (props) => (
            <div className="text-justify" style={{ paddingBottom: 10, ...props.style }}>
                {props.children}
            </div>
        );

        const ParagraphWithMargin = (props) => (
            <div className="text-justify" style={{ paddingBottom: 10, ...props.style, marginLeft: 20 }}>
                {props.children}
            </div>
        );

        return (
            <Layout notShowMarginBottom>
                <div className="container">
                    <div className="row">
                        <h4 className={styles.mainText}>
                            <FormattedMessage id="modal-kwallet-activate-affidavit" defaultMessage="Affidavit Certification" />
                        </h4>
                    </div>
                    <div className="row">
                        <div className="col">
                            <div className={styles.privacyBackround}>
                                <Paragraph>
                                    <FormattedMessage id="affidavit-certification-1" defaultMessage="affidavit-certification-1" />
                                    <br />
                                    <FormattedMessage id="affidavit-certification-2" defaultMessage="affidavit-certification-2" />
                                </Paragraph>
                                <ParagraphWithMargin>
                                    <FormattedMessage id="affidavit-certification-2-1" defaultMessage="affidavit-certification-3" />
                                </ParagraphWithMargin>
                                <ParagraphWithMargin>
                                    <FormattedMessage id="affidavit-certification-2-2" defaultMessage="affidavit-certification-4" />
                                </ParagraphWithMargin>
                                <ParagraphWithMargin>
                                    <ParagraphWithMargin>
                                        <FormattedMessage id="affidavit-certification-2-2-1" defaultMessage="affidavit-certification-5" />
                                    </ParagraphWithMargin>
                                    <ParagraphWithMargin>
                                        <FormattedMessage id="affidavit-certification-2-2-2" defaultMessage="affidavit-certification-6" />
                                    </ParagraphWithMargin>
                                    <ParagraphWithMargin>
                                        <FormattedMessage id="affidavit-certification-2-2-3" defaultMessage="affidavit-certification-7" />
                                    </ParagraphWithMargin>
                                </ParagraphWithMargin>
                                <Paragraph>
                                    <FormattedMessage id="affidavit-certification-3" defaultMessage="affidavit-certification-8" />
                                </Paragraph>
                                <ParagraphWithMargin>
                                    <Paragraph>
                                        <FormattedMessage id="affidavit-certification-3-1" defaultMessage="affidavit-certification-9" />
                                    </Paragraph>
                                    <Paragraph>
                                        <FormattedMessage id="affidavit-certification-3-2" defaultMessage="affidavit-certification-10" />
                                    </Paragraph>
                                    <Paragraph>
                                        <FormattedMessage id="affidavit-certification-3-3" defaultMessage="affidavit-certification-10" />
                                    </Paragraph>
                                </ParagraphWithMargin>
                                <Paragraph>
                                    <FormattedMessage id="affidavit-certification-4" defaultMessage="affidavit-certification-10" />
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage id="affidavit-certification-5" defaultMessage="affidavit-certification-10" />
                                </Paragraph>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        );
    }
}

export default injectIntl(AffidavitCertification);



/** WEBPACK FOOTER **
 ** ./src/components/pages/affidavit-certification.jsx
 **/